import { FC } from 'react'
import Avatar, { AvatarProps } from '@mui/material/Avatar'

/* eslint-disable import/no-webpack-loader-syntax */
import pennant from '!!file-loader!assets/icons/pennant.png'
import roundTable from '!!file-loader!assets/icons/round-table.png'
import pmt from '!!file-loader!assets/tokens/pmt.png'
import trophy from '!!file-loader!assets/arena/trophy.png'

import knight01 from '!!file-loader!assets/icons/knight-01.png'
import knight02 from '!!file-loader!assets/icons/knight-02.png'
import knight03 from '!!file-loader!assets/icons/knight-03.png'
import knight04 from '!!file-loader!assets/icons/knight-04.png'
import knight05 from '!!file-loader!assets/icons/knight-05.png'
import knight06 from '!!file-loader!assets/icons/knight-06.png'
import knight07 from '!!file-loader!assets/icons/knight-07.png'
import knight08 from '!!file-loader!assets/icons/knight-08.png'
import knight09 from '!!file-loader!assets/icons/knight-09.png'
import knight10 from '!!file-loader!assets/icons/knight-10.png'
import knight11 from '!!file-loader!assets/icons/knight-11.png'
import knight12 from '!!file-loader!assets/icons/knight-12.png'
/* eslint-enable import/no-webpack-loader-syntax */

export const Pennant: FC<AvatarProps> = (props) => (
  <Avatar src={pennant} {...props} />
)

export const RoundTable: FC<AvatarProps> = (props) => (
  <Avatar src={roundTable} {...props} />
)

export const PMT: FC<AvatarProps> = (props) => (
  <Avatar src={pmt} {...props} />
)

export const Trophy: FC<AvatarProps> = (props) => (
  <Avatar src={trophy} {...props} variant="square" />
)

const knights = [
  knight01,
  knight02,
  knight03,
  knight04,
  knight05,
  knight06,
  knight07,
  knight08,
  knight09,
  knight10,
  knight11,
  knight12,
]
export const Knight: FC<AvatarProps & { tokenId: number}> = ({ tokenId, ...props}) => {
  return <Avatar src={knights[tokenId - 1]} {...props} />
}
